import { render } from "./ValidateAppointment.vue?vue&type=template&id=1e31a2d6"
import script from "./ValidateAppointment.vue?vue&type=script&lang=js"
export * from "./ValidateAppointment.vue?vue&type=script&lang=js"

import "./ValidateAppointment.vue?vue&type=style&index=0&id=1e31a2d6&lang=css"
script.render = render

export default script